import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { breakpointDown } from '../utils/breakpoints'

gsap.registerPlugin(ScrollTrigger)

function init() {
  const block = document.querySelector('.block-scroll-gallery .tiles')

  if(!block) return false

  const line_1 = block.querySelector('.tiles__line_1')
  const line_2 = block.querySelector('.tiles__line_2')
  const line_3 = block.querySelector('.tiles__line_3')

  let data = {
    start: 'top bottom'
  }

  if(breakpointDown('sm')) {
    data.start = 'top bottom-=15%'
  }

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: block,
      start: data.start,
      end: 'bottom center',
      scrub: 1,
      // markers: true
    }
  })

  tl.fromTo(line_1, { y: '10%' }, { y: '-15%' }, 0)
  tl.fromTo(line_3, { y: '10%' }, { y: '-15%' }, 0)
  tl.fromTo(line_2, { y: '-10%' }, { y: 0 }, 0)



}

init()
